import { TransProps, useTranslation } from 'react-i18next';

import { UseArtworkBoxSoldSummary, ArtworkOrderDetails, BillingAddressFormData, DeliveryDetailsSettings } from '../../interfaces';

export const useArtworkBoxSoldSummaryHook: (
  ordersDetails: ArtworkOrderDetails
) => UseArtworkBoxSoldSummary = (ordersDetails: ArtworkOrderDetails): UseArtworkBoxSoldSummary => {
  const { t }: TransProps<never> = useTranslation();

  const onFormatAddress: (address: BillingAddressFormData & { phone?: string; email?: string }) => string = (
    address: BillingAddressFormData & { phone?: string; email?: string }
  ): string => {
    
    const name: string = `${address.firstName} ${address.lastName}\n`;
    const companyName: string = address.companyName
      ? `${address.companyName}\n`
      : '';
    const taxId: string = address.taxId
      ? `${t('onarte.common.taxIdPrefix', { value: address.taxId })}\n`
      : '';
    const email: string = address.email
      ? `${address.email}\n`
      : '';
    const phone: string = address.phone
      ? `${address.phone}\n`
      : '';
    const apartmentNumber: string = address.apartmentNumber
      ? `\/${address.apartmentNumber}`
      : '';
    const street: string = `${t('onarte.common.streetPrefix', { value: address.street})} ${address.houseNumber}${apartmentNumber}\n`;

    return `${name}${companyName}${taxId}${email}${phone}${street}${address.postalCode} ${address.city}`;
  };

  const deliveryDetailsConfig: DeliveryDetailsSettings[] = [
    {
      key: t('onarte.ui.useArtworkBoxSoldSummary.deliveryDetailsConfig.id'),
      value: ordersDetails.id
    },
    {
      key: t('onarte.ui.useArtworkBoxSoldSummary.deliveryDetailsConfig.invoice'),
      value: ordersDetails.hasInvoice && ordersDetails.billingAddress 
        ? onFormatAddress(ordersDetails.billingAddress)
        : t('onarte.ui.useArtworkBoxSoldSummary.deliveryDetailsConfig.withoutInvoice')
    },
    {
      key: t('onarte.ui.useArtworkBoxSoldSummary.deliveryDetailsConfig.paymentType'),
      value: ordersDetails.paymentTypeLabel
    },
    {
      key: t('onarte.ui.useArtworkBoxSoldSummary.deliveryDetailsConfig.paymentStatus'),
      value: ordersDetails.paymentStatusLabel
    },
    {
      key: t('onarte.ui.useArtworkBoxSoldSummary.deliveryDetailsConfig.commentToOrder'),
      value: ordersDetails.commentToOrder || '&#150;'
    },
    {
      key: t('onarte.ui.useArtworkBoxSoldSummary.deliveryDetailsConfig.shippingAddress'),
      value: onFormatAddress(ordersDetails.shippingAddress)
    },
    ...(ordersDetails.sourceParcelAddress
      ? [{
        key: t('onarte.ui.useArtworkBoxSoldSummary.deliveryDetailsConfig.sourceParcelAddress'),
        value: onFormatAddress(ordersDetails.sourceParcelAddress)
      }]
      : []
    ),
  ];

  return { deliveryDetailsConfig };
};
